import React from "react";
import { Stack } from "@chakra-ui/layout";
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Input,
  Checkbox,
  Button,
} from "@chakra-ui/react";
import SearchIcon from "../assets/iconz/Search.png";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
} from "@chakra-ui/react";

const individualLearners = [
  {
    name: "Ebitimi Cocodia",
    _id: "1",
  },
  {
    name: "Ebitimi Cocodia",
    _id: "2",
  },
  {
    name: "Ebitimi Cocodia",
    _id: "3",
  },
  {
    name: "Ebitimi Cocodia",
    _id: "4",
  },
  {
    name: "Ebitimi Cocodia",
    _id: "5",
  },
];

const groupLearners = [
  {
    name: "Year 1",
    _id: "1",
  },
  {
    name: "Year 2",
    _id: "2",
  },
  {
    name: "Year 3",
    _id: "3",
  },
  {
    name: "Year 4",
    _id: "4",
  },
  {
    name: "Year 5",
    _id: "5",
  },
];

const AssignLearner = ({ id, action, close }) => {
  // console.log(id);
  const [learnerId, setLearnerId] = React.useState([]);
  const [groupId, setGroupId] = React.useState([]);

  const handleLearnerClick = (e) => {
    if (e.target.value) {
      if (e.target.checked) {
        setLearnerId([...learnerId, e.target.value]);
      } else {
        setLearnerId((prev) => prev.filter((old) => old !== e.target.value));
      }
    }
  };

  const handleGroupClick = (e) => {
    if (e.target.value) {
      if (e.target.checked) {
        setGroupId([...groupId, e.target.value]);
      } else {
        setGroupId((prev) => prev.filter((old) => old !== e.target.value));
      }
    }
  };

  // console.log(groupId, learnerId);

  return (
    <div>
      <Modal
        isOpen={action === "learner"}
        onClose={close}
        scrollBehavior="inside"
        size="lg"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader bg="#F6F7FB" pb="1rem">
            {" "}
            {action === "learner"
              ? "Assign to Learner"
              : "Assign to Instructor"}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Tabs variant="unstyled">
              <TabList
                borderBottom="1px"
                borderColor="gray.200"
                pb="1rem"
                pos="relative"
              >
                <Tab
                  _selected={{ color: "white", bg: "blue.500" }}
                  borderRadius="md"
                >
                  Individual
                </Tab>
                <Tab
                  _selected={{ color: "white", bg: "blue.500" }}
                  borderRadius="md"
                >
                  Group
                </Tab>
                <SearchIconComponent />
                <Input
                  placeholder="Search"
                  variant="unstyled"
                  size="md"
                  width="50%"
                  ml="1rem"
                />
              </TabList>
              <TabPanels>
                <TabPanel>
                  <Stack>
                    {individualLearners.map((learner, index) => (
                      <Checkbox
                        value={learner._id}
                        pb="1rem"
                        borderBottom="1px"
                        borderColor="gray.200"
                        onClick={handleLearnerClick}
                      >
                        {learner.name}
                      </Checkbox>
                    ))}
                  </Stack>
                </TabPanel>

                <TabPanel>
                  <Stack>
                    {groupLearners.map((learner) => (
                      <Checkbox
                        value={learner._id}
                        pb="1rem"
                        borderBottom="1px"
                        borderColor="gray.200"
                        onClick={handleGroupClick}
                      >
                        {learner.name}
                      </Checkbox>
                    ))}
                  </Stack>
                </TabPanel>
              </TabPanels>
            </Tabs>
          </ModalBody>
          <ModalFooter>
            <Button style={{ background: "#213C5C", color: "white" }}>
              {" "}
              Assign
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default AssignLearner;

const SearchIconComponent = () => (
  <img
    src={SearchIcon}
    alt="search"
    style={{
      position: "absolute",
      top: "15%",
      right: "0",
      width: "50px",
    }}
  />
);
